import styled from "@emotion/styled";
import Colors from "/styles/colors";
export const StyledMediaItem = styled.div`
  display: flex;

  &.row {
    flex-direction: row;

    .media-item--icon-wrapper {
      width: 48px;
      height: 48px;
      margin-right: 16px;
      margin-bottom: 16px;

      .media-item--icon {
        width: 100%;
        height: 100%;
      }
    }
  }

  &.column {
    flex-direction: column;
    width: 328px;

    .media-item--text {
      margin-top: 8px;
    }

    .media-item--icon-wrapper {
      height: auto;
      width: 100%;
    }
  }

  .media-item--icon-wrapper {
    border-radius: 8px;
  }

  .media-item--text {
    color: ${Colors["mud"]};
    font-size: 0.875rem;
    width: 256px;
    line-height: 22px;

    .media-item--title {
      font-weight: bold;
    }

    .media-item--subtitle {
      font-weight: 300;
    }
  }
`;
